namespace $.$$ {
	
	$mol_style_define( $shm_hitalama_map_editor, {

		flex: {
			shrink: 0,
		},
		scrollSnapStop: 'always',
		scrollSnapAlign: 'end',

		Widget_code_content: {
			flex: {
				direction: 'column'
			},
		},
		
		Edit_page: {
			background: {
				color: 'transparent'
			},
			flex: {
				grow: 1,
			},
			Head: {
				justify: {
					content: 'flex-start',
				},
			},
			scrollSnapStop: 'always',
			scrollSnapAlign: 'end',
		},

		Preview_page: {
			Head: {
				justify: {
					content: 'flex-start'
				},
			},
			Body_content: {
				height: '100%',
			},
			scrollSnapStop: 'always',
			scrollSnapAlign: 'end',
		},

		Pin: {
			margin: {
				right: 'auto',
			},
		},

		Unpin: {
			color: $mol_theme.current,
			margin: {
				right: 'auto',
			},
		},

		Title: {
			['fieldSizing' as any]: 'content',
			flex: {
				grow: 0,
			},
		},

		Cut_pick: {
			borderTop: '1px solid var(--mol_theme_line)',
			margin: {
				top: '1rem',
			},
			Trigger: {
				color: '#ff6666',
			},
			color: '#ff6666',
		},

		Settings_content: {
			padding: $mol_gap.block,
			width: '15rem',
		},

		Description_field: {
			padding: {
				bottom: $mol_gap.block,
			},
		},

		Settings_free_space: {
			flex: {
				grow: 1,
			},
		},
		
	} )
	
}
